import React, { memo, useCallback } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Product } from "../../../gobalType";

type PlantNameListProps = {
  rows: { name: string; product: Product }[];
  onSelect: (product: Product) => void;
  emptyMessage?: string;
};

const PlantNameList: React.FC<PlantNameListProps> = ({
  rows,
  onSelect,
  emptyMessage = "No plants found",
}) => {
  const handleKeyActivate = useCallback(
    (e: React.KeyboardEvent, product: Product) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onSelect(product);
      }
    },
    [onSelect]
  );

  if (rows.length === 0) {
    return (
      <Typography sx={{ px: 2, py: 3, color: "#888", textAlign: "center" }}>
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Box component="nav" aria-label="Plant names" sx={{ px: 0 }}>
      {rows.map(({ name, product }) => (
        <Box
          key={name}
          role="button"
          tabIndex={0}
          onClick={() => onSelect(product)}
          onKeyDown={(e) => handleKeyActivate(e, product)}
          sx={{
            px: 2,
            py: 1.75,
            borderBottom: "1px solid #ebebeb",
            cursor: "pointer",
            "&:active": { bgcolor: "#f7f7f7" },
          }}
        >
          <Typography sx={{ fontSize: 16, color: "#222", fontWeight: 400 }}>
            {name}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default memo(PlantNameList);
